

import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TooltipVariants from "@/entities/TooltipVariants";
import Tooltip from "@/components/common/Tooltip.vue";

@Component({
    components: {
        Tooltip
    },
})
export default class ActivityItem extends Vue {
    @Prop({ type: Object, default: null }) readonly item!: any;
    @Prop({ type: String, default: null }) readonly color!: any;
    @Prop({ type: Number, default: null }) readonly index!: number;
    TooltipVariants = TooltipVariants;
}
